import {
  Box,
  styled,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
  Button,
  TableCell,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  TableBody,
} from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import useLoadDataList from 'src/hook/useLoadDataList';
import { deleteStock, getStocks, updateStock } from 'src/services/stock';
import { handleMutation } from 'src/utils/api.utils';

export const EditStock = () => {
  const { data: stocks, onRefresh } = useLoadDataList(getStocks);

  const [quantity, setQuantity] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');

  const [selectedStock, setSelectedStock] = useState<string>('');

  const handleUpdate = (id: string) => {
    handleMutation(
      (data) => updateStock(id, data),
      {
        quantity: Number.parseInt(quantity, 10),
        price: Number.parseFloat(price),
        name,
      },
      () => {
        toast.success('Stock supprimé avec succès');
        onRefresh();
      },
    );
  };

  const handleStockChange = (event: SelectChangeEvent) => {
    setSelectedStock(event.target.value);
    const stock = stocks?.find((s) => s.id === event.target.value);
    setQuantity(stock?.quantity.toString() ?? '0');
    setPrice(stock?.price.toString() ?? '0');
    setName(stock?.name ?? '');
  };

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Liste des stocks
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="assembly-label">Choisir un assemblage</InputLabel>
        <Select
          labelId="assembly-label"
          id="assembly-select"
          value={selectedStock}
          label="Assemblage"
          onChange={handleStockChange}
          required
        >
          {stocks?.map((stock) => {
            return (
              <MenuItem
                key={stock.id}
                value={stock.id}
                sx={{ display: 'flex', alignItems: 'center', gap: 2, flexDirection: 'row' }}
              >
                <Typography variant="body1">{stock.name}</Typography>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        label="Quantité"
        type="number"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
        required
        inputProps={{ min: 1 }}
      />

      <TextField
        fullWidth
        label="Prix"
        type="number"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        required
        inputProps={{ min: 0, step: 1 }}
      />

      <TextField
        fullWidth
        label="Nom"
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        onClick={() => handleUpdate(selectedStock)}
      >
        Modifier le stock
      </Button>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '20px',
});

const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});
